/**
 * 
 */

function fadeInAnimation(type){
	$(`#${type}MenuBackground`).addClass('fade-in__header-menu--background');
	setTimeout( () => {
		$(`#${type}SideMenuBackground`).addClass('move-left-origin');
		$(`#${type}SideMenuSelectBar`).addClass('move-left-origin');
		$(`#${type}SideMenu`).addClass('move-left-origin');
		setTimeout( () => {
			$(`#${type}CloseBar`).addClass('fade-in__header-menu--close-bar');
			setTimeout( () => {
				$(`#${type}SideMenuSelectBar`).addClass('change-size__header-menu--side-bar');
				$(`#${type}CloseButtonBox`).addClass('scale-up__button');
				$('.p-menu__modal-side-li').addClass('fade-in__header-menu--side-bar');
				setTimeout( () => {
					$(`#${type}MenuCloseButton`).addClass('fade-in__opacity');
					$(`#${type}MenuSelectArrow`).addClass('fade-in__opacity');
					$(`#${type}MainContent`).fadeIn();
				}, 200)
			}, 200)
		}, 100)
	}, 200)
}

function closeAnimation(type) {
	$(`#${type}MenuBackground`).fadeOut(500, function() {
		$(`#${type}MenuBackground`).removeClass('fade-in__header-menu--background');
		$(`#${type}SideMenuBackground`).removeClass('move-left-origin');
		$(`#${type}SideMenuSelectBar`).removeClass('move-left-origin');
		$(`#${type}SideMenu`).removeClass('move-left-origin');
		$(`#${type}CloseBar`).removeClass('fade-in__header-menu--close-bar');
		$(`#${type}SideMenuSelectBar`).removeClass('change-size__header-menu--side-bar');
		$(`#${type}CloseButtonBox`).removeClass('scale-up__button');
		$(`.p-menu__modal-side-li`).removeClass('fade-in__header-menu--side-bar');
		$(`#${type}MenuCloseButton`).removeClass('fade-in__opacity');
		$(`#${type}MenuSelectArrow`).removeClass('fade-in__opacity');
		$(`#${type}MenuBackground`).css('display', '');
		$(`#${type}SideMenuSelectBar`).css('transform', '');
		$(`#${type}MainContent`).css('display', '');
		$('.p-content__modal-main-li').css('display', '');
		$('.p-content__modal-main-li' + '.show').removeClass('show');
		$('.p-content__modal-main-li' + '.fast').addClass('show');
	});
}

$(function(){
	
	var controller = new ScrollMagic.Controller();
	var scene = new ScrollMagic.Scene({ offset: 230,triggerHook: "onLeave"})
	.setClassToggle("#headerSmall", "l-header-top__small--moved")
	.addTo(controller); // Controllerに追加
	
	
	$('#openGlovalMenu, #openGlovalMenuLogo').on('click', () => {
		fadeInAnimation('gloval');
	})
	
	$('#openContactMenu, #openContactMenuPrefecture').on('click', () => {
		fadeInAnimation('contact');
	})
	
	$('#openSearchStoreMenu, #openSearchStoreMenuPrefecture').on('click', () => {
		fadeInAnimation('searchStore');
	})
	
	$('#glovalMenuCloseButton, #glovalMenuCloseButtonSp').on('click', () => {
		closeAnimation('gloval');
	})
	
	$('#contactMenuCloseButton, #contactMenuCloseButtonSp').on('click', () => {
		closeAnimation('contact');
	})
	
	$('#searchStoreMenuCloseButton, #searchStoreMenuCloseButtonSp').on('click', () => {
		closeAnimation('searchStore');
	})
	
	$('.p-menu__modal-side-li').hover( function() {
		let index = $(this).index('.p-menu__modal-side-li:visible');
		let movePos = index * 8;
		if($(".p-menu__modal-side--select-bar-gloval").is(":visible")) {
			$('.p-menu__modal-side--select-bar-gloval').css('transform', `translateY(${movePos}rem)`);
		} else if($(".p-menu__modal-side--select-bar-contact").is(":visible")) {
			$('.p-menu__modal-side--select-bar-contact').css('transform', `translateY(${movePos}rem)`);
		} else if($(".p-menu__modal-side--select-bar-search-store").is(":visible")) {
			$('.p-menu__modal-side--select-bar-search-store').css('transform', `translateY(${movePos}rem)`);
		}
	})
	
	$('.p-button__sp-modal-content-close, .p-button__sp-modal-content-open').on('click', function() {
		$(this).next().slideToggle();
		if($(this).attr('class') == 'p-button__sp-modal-content-close') {
			$(this).attr('class', 'p-button__sp-modal-content-open');
		} else {
			$(this).attr('class', 'p-button__sp-modal-content-close');
		}
	})
	
	$(window).on("scroll touchmove", function(){ //スクロール中に判断する
		if($(window).width() < 768) {
			$("#headerSpNavi").stop(); //アニメーションしている場合、アニメーションを強制停止
			$("#headerSpNavi").css('display', 'none').delay(500).fadeIn('fast');
			//スクロール中は非表示にして、500ミリ秒遅らせて再び表示
		} else {
			$("#headerSpNavi").css('display', 'none');
		}
	});
	
	
	$.ajax({
		url: '/api/store/index',
		type: 'GET',
		dataType: 'json',
	}).done(function(data) {
		for(let i in data) {
			let area = data[i]
			
			let areaPrefecture = 
				`<li class="p-area-box-li">
					<button class="c-button__modal--link-ul">${i}</button>
					<ul class="p-area__sort-ul">`;
			
			let prefectureLists =''
			for(let j in area) {
				let prefecture = area[j]
				let prefectureStores =
					`<li class="p-area__sort-li">
						<button class=c-button__modal--link-li-close>${j}</button>
						<ul class="p-area__ul">`;
		  		for(let k in prefecture) {
					let store = prefecture[k];
					let serviceId = store['service_id'];
					let tel = store['tel'][0];
					if(tel == "") {
						tel = store['tel'][1];
					}
					let serviceName;
					switch(serviceId) {
						case 1:
							serviceName = 'トランクルーム';
							break;
						case 2:
							serviceName = 'レンタル収納スペース';
							break;
						case 3:
							serviceName = '文書保管';
							break;
						case 4:
							serviceName = 'レンタル収納スペース';
							break;
					}
					prefectureStores +=
						`<li class="p-area__li">
							<div class="p-card__modal-main">
								<p class="c-text__modal--store-type--${serviceId}">${serviceName}</p>
								<div class="p-card__modal-main--image"><a href="tel:${tel}"><img class="c-image__modal--icon" src="/images/icon_phone.svg"></a></div>
								<div class="p-card__modal-main--text">
									<a href="${store['store_url']}" class="c-text__modal--main-text">押入れ産業${store['store_name']}(${store['location']['company']['company_name']} | ${store['location']['address_pref']}${store['location']['address_city']})</a>
									<p class="c-text__modal--main-text-sub">〒${store['location']['zip']} ${store['location']['address_pref']}${store['location']['address_city']}${store['location']['address']} ／ ${tel}</p>
								</div>
							</div>
						</li>`;
				}
				prefectureStores += '</ul></li>';
				prefectureLists += prefectureStores;
			}
			areaPrefecture += prefectureLists;
			areaPrefecture += '</ul></li>';
			$('.p-area-box-ul').append(areaPrefecture);
		}
	}).fail(function( jqXHR, textStatus, errorThrown) {
		
	}).always(function( jqXHR, textStatus) {
		
	});
	
	$(document).on('click', '.c-button__modal--link-li-close, .c-button__modal--link-li-open',function() {
		$(this).next().slideToggle();
		if($(this).attr('class') == 'c-button__modal--link-li-close') {
			$(this).attr('class', 'c-button__modal--link-li-open');
		} else {
			$(this).attr('class', 'c-button__modal--link-li-close');
		}
	})
	
	$(document).on('click', '.c-button__modal--link-ul', function() {
		$(this).next().slideToggle();
	})
	
	let fadeIn = true;
	let fadeOut = true;
	$('.p-menu__modal-side-li').on('click', function() {
		if(fadeIn && fadeOut) {
			let openContentId = $(this).attr('id') + 'Main';
			let indexSideMenu = $(this).index('.p-menu__modal-side-li:visible');
			let currentIndex = $('.p-content__modal-main-li:visible' + '.show:visible').index();
			if( indexSideMenu != currentIndex) {
				fadeIn = false;
				fadeOut = false;
				$('.p-content__modal-main-li:visible' + '.show:visible').fadeOut(200, function(){
					$('.p-content__modal-main-li' + '.show').removeClass('show').css('display', 'none');
					fadeIn = true;
				});
				$(`#${openContentId}`).fadeIn(200, function() {
					$(`#${openContentId}`).addClass('show');
					fadeOut = true;
				});
			}
		}
	})
	
	$('#searchStoreFormButton').on('click', function() {
		let keyword = $('#searchStoreFormInput').val();
		window.location.href = `/map/?kw=${keyword}`;
	})
})


